let paymentCurrency = '';

export function setPaymentCurrency(currency: string): void {
  paymentCurrency = currency.trim().toUpperCase();
}

export function formatPaymentMoney(amount: number): string {
  if (!paymentCurrency) return amount.toLocaleString('en-US');
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: paymentCurrency,
      minimumFractionDigits: 0,
    }).format(amount);
  } catch {
    return `${amount.toLocaleString('en-US')} ${paymentCurrency}`;
  }
}
